// extracted by mini-css-extract-plugin
module.exports = {"container":"GenresScreen_container__IP1PM","filters":"GenresScreen_filters__zz5eV","grid":"GenresScreen_grid__0Uf9r","loader":"GenresScreen_loader__IidGO"};